import React from 'react';
import PropTypes from 'prop-types';

const NumberLabel = ({ value , maximumFractionDigits , precision = 0 }) => {
    return <span>{isFinite(value) ?  Number(value).toLocaleString(undefined,{ minimumFractionDigits: precision , maximumFractionDigits }) : value }</span>
};

NumberLabel.propTypes = {
    value: PropTypes.any,
    precision: PropTypes.number,
    maximumFractionDigits: PropTypes.number
};


export default NumberLabel;


// WEBPACK FOOTER //
// ./src/components/NumberLabel/NumberLabel.js